<template>
	<div class="home">
		<!-- <div class="top autoFlex">
     
      <span></span>
      <span>编辑</span>
      
    </div> -->
		<div class="banner">
			<img src="../assets/bg.png" alt="" />
		</div>
		<div class="main">
			<div class="item items">
				<van-field name="radio" label="是否本公司职工">
					<template #input>
						<van-radio-group v-model="forms.check" direction="horizontal" @change="getValue">
							<van-radio name="1">是</van-radio>
							<van-radio name="2">否</van-radio>
						</van-radio-group>
					</template>
				</van-field>
			</div>
			<div class="item" v-if="forms.check == 1">
				<van-field v-model="fieldValue" is-link readonly label="所属部门" placeholder="请选择所属部门"
					@click="getDepart" />
				<van-popup v-model="show" round position="bottom">
					<van-cascader v-model="cascaderValue" title="请选择所属部门" :options="options" @close="show = false"
						@change="onChange" @finish="onFinish" />
				</van-popup>
			</div>
			<div class="item" v-if="forms.check == 2">
				<van-cell-group>
					<van-field v-model="forms.company" label="公司名称" placeholder="请输入公司名称" />
				</van-cell-group>
			</div>
			<div class="item">
				<van-cell-group>
					<van-field v-model="forms.name" label="姓名" placeholder="请输入姓名" />
				</van-cell-group>
			</div>
			<div class="item items">
				<van-field name="radio" label="性别">
					<template #input>
						<van-radio-group v-model="forms.sex" direction="horizontal">
							<van-radio name="0">男</van-radio>
							<van-radio name="1">女</van-radio>
						</van-radio-group>
					</template>
				</van-field>
			</div>
			<div class="item autoFlex">
				<van-cell plain type="primary" @touchstart.native.stop="showID = true">
					身份证号码
				</van-cell>
				<van-field @focus='selectDate' clickable :value="forms.personNo" @touchstart.native.stop="showID = true" />
				<van-number-keyboard v-model="forms.personNo" :show="showID" extra-key="X" close-button-text="完成"
					@blur="showID = false" @input="onInput" @delete="onDelete" />
			</div>
			<div class="item autoFlex">
				<van-cell @touchstart.native.stop="showPhone = true">手机号码</van-cell>
				<van-field  @focus='selectDate' clickable :value="forms.phoneNum" @touchstart.native.stop="showPhone = true" />
				<van-number-keyboard v-model="forms.phoneNum" :show="showPhone" :maxlength="11"
					@blur="showPhone = false" />
			</div>
			<div class="item autoFlexNoJust" style="margin-top:20px">
				<van-cell class="avatar">人脸照</van-cell>
				<van-uploader :after-read="afterRead" :max-count="1" v-model="fileList" class="uploader">
					<!-- <span>点击调用摄像头进行拍摄</span> -->
				</van-uploader>

			</div>
			<!-- <div class="item" style="display: flex;align-items: center;">
				<van-field v-model="forms.code" label="" placeholder="请输入验证码" />
				<van-button round type="info" size="normal" class='btns'>获取验证码</van-button>
			</div> -->
			<!-- <div class="item itemMargin">
				<van-checkbox-group v-model="result" direction="horizontal" @change="getCheck">
					<van-checkbox :name="item" shape="square" v-for="(item, index) in authList" :key="index">
						{{ item.name }}</van-checkbox>
				</van-checkbox-group>
			</div> -->
			<div class="item itemLength">
				<van-button round type="info" size="normal" class="btns" @click="userRegest">注册</van-button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	import {
		regesterUser,
		getDepartments,
		getAuth,
		uploadImg
	} from "../apis/api.js";
	import{isIdentityId} from "../utils/index.js" ;
	export default {
		data() {
			return {
				result: [],
				fileList: [],
				isChecked: true,
				isCheckeds: false,
				showID: false,
				belongParts: "请选择所属部门",
				show: false,
				showPhone: false,
				fieldValue: "",
				forms: {
					name: "",
					sex: "0",
					check: "1",
					code: "",
					phoneNum: "",
					personNo: "",
					company: "",
				},
				cascaderValue: "",
				options: [],
				iscompany: 1,
				authList: [],
				checkedAuth: [],
				departId: '',
				personImg: ''
			};
		},
		mounted() {
			document.title = "注册";
			// localStorage.clear()
			this.getAuths();

		},
		methods: {
			selectDate(){
				        document.activeElement.blur();
				    },
			onOversize(file) {
				console.log(file);
				Toast('文件大小不能超过 500kb');
			},
			afterRead(file) {
				// 此时可以自行将文件上传至服务器
				console.log(file);
				file.status = 'uploading';
				file.message = '上传中...';
				uploadImg({
					img: file.content,
					openId: localStorage.getItem('openId'),
					ext: file.file.name.split('.')[1]
				}).then(res => {
					console.log(res)
					Toast('上传成功')
					this.personImg = res.result.savePath;
					file.status = 'done';
					file.message = '上传成功';
				})
			},
			getCheck(item) {

				item.forEach(iitem => {
					iitem.authority = 1
				})
				this.checkedAuth = item;

			},
			getValue(value) {
				console.log(value);
				this.forms.company = ''
				this.fieldValue = ''
				if (value == 1) {
					this.iscompany = 1;
				} else {
					this.iscompany = 0;
				}

				// this.getAuths();
			},
			getAuths() {
				getAuth({
					iscompany: this.iscompany
				}).then((res) => {
					console.log(res.result);
					this.authList = res.result;
				});
			},
			getDepart() {
				this.show = true;
				getDepartments().then((res) => {
					console.log(res);
					this.options = res.result.map((item) => {
						item.text = item.departName;
						item.value = item.id;
						if( item.departList.length>0){
							item.children = item.departList;
							item.children.forEach(iitem => {
								iitem.text = iitem.departName
								iitem.value = iitem.id;
							})
						}
						
						return item;
					});
				});
			},
			userRegest() {
				let _this = this;
				if (this.forms.name == "") {
					this.$toast("请输入姓名");
					return;
				} 
				if (this.forms.phoneNum == "") {
					this.$toast("请输入手机号码");
					
					return;
				} 
				if (this.forms.phoneNum != "")
				{
					var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
					if (!phonereg.test(this.forms.phoneNum )) {
						this.$toast("手机号码格式不正确");
						return;
					}
				}

				if (this.forms.personNo == "") {
					this.$toast("请输入身份证号码");
					return;
				} 

				if(this.forms.personNo!=null)
				{
					var errorMsg=isIdentityId(this.forms.personNo);
					if(errorMsg!="")
					{
						this.$toast(errorMsg);
						return;
					}
				}

				if(this.personImg==''){
					this.$toast("请上传人脸照");
					return;
				} 
				
				console.log(localStorage.getItem('path'))
				// this.$router.push(localStorage.getItem('path'))
					// this.$router.push(localStorage.getItem('path'))
				regesterUser({
					personName: this.forms.name,
					phoneNum: this.forms.phoneNum,
					personNo: this.forms.personNo,
					personSex: this.forms.sex,
					departId: this.departId,
					companyName: this.forms.company,
					// authorityList: this.checkedAuth,
					openId: localStorage.getItem('openId') || '',
					personImg: this.personImg
				}).then((res) => {
					this.$toast("注册成功");
					window.location.reload()
					// this.$router.push(localStorage.getItem('path')) 
				});
				
			},
			onInput(value) {
				console.log(value);
			},
			onDelete() {},
			onChange({
				value
			}) {

			},
			onFinish({
				selectedOptions
			}) {
				this.show = false;
				this.fieldValue = selectedOptions.map((option) => option.text).join("/");
				console.log()
				this.departId = selectedOptions.pop().value;
			},
			onSubmit(values) {
				console.log("submit", values);
			},
			checkoutYes() {
				console.log("yes");
				this.isChecked = true;
				this.isCheckeds = false;
			},
			checkoutNo() {
				this.isChecked = false;
				this.isCheckeds = true;
				console.log("no");
			},
		},
	};
</script>

<style lang="less" scoped>
	.itemLength {
		width: 100%;
		margin-top: 30px;
		text-align: center;

		.btns {
			// width: 100%;
			height: 80px;
			width: 70%;
		}
	}

	.btns {
		width: 50%;
		height: 60px;
	}

	.home .avatar::after {
		border: none;

	}

	.home .avatar {
		width: 20% !important;
	}

	.home {
		background: url(../assets/regest/bg.jpg) no-repeat;
		background-size: 100% 100%;
		min-height: 100vh;
		width: 100%;
	}

	.itemMargin {
		margin-top: 30px;
	}

	.banner {
		width: 100vw;

		img {
			width: 100vw;
			height: 340px;
			// margin-top: 100px;
		}
	}

	.top {
		display: flex;
		padding: 40px 20px;

		.close_btn {
			font-size: 40px;
		}

		span {
			font-size: 32px;
			// font-weight: bold;
			color: #333;
		}
	}

	.main {
		padding: 0 30px;

		.items {
			border-bottom: 1px solid #ebedf0;
			// padding-bottom: 20px;
			// margin-top: 30px;
		}

		.item {
			.label {
				// margin-right: 30px;
				width: 220px;

				font-size: 26px;
			}

			.align_right {
				margin-right: 80px;

				img {
					margin-right: 10px;
				}
			}
		}
	}
</style>
